import React from 'react';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

import { useModalPaymentLinkBoletoBootstrap } from './modalPaymentLinkBoleto.bootstrap.hook';
import { ModalDialog, ModalOverlay } from '../styles';
import { ISubmitPaymentLinkOneTimePayment } from '../types/types';
import {
  ButtonsRow,
  CloseButton,
  CopyButton,
  DeadlineNotice,
  Description,
  IconWrapper,
  LineField,
  Title,
  ViewBoletoButton,
} from './style';

interface ModalPaymentLinkBoletoProps {
  open: boolean;
  data?: ISubmitPaymentLinkOneTimePayment;
  onClose: () => void;
}

export const ModalPaymentLinkBoleto: React.FC<ModalPaymentLinkBoletoProps> = ({
  open,
  data,
  onClose,
}) => {
  const {
    copied,
    line,
    handleCopyLine,
    canCopy,
    handleOpenBoleto,
    canOpenBoleto,
    dueAtLabel,
  } = useModalPaymentLinkBoletoBootstrap(data);

  return (
    <ModalOverlay $open={open}>
      <ModalDialog>
        <IconWrapper>
          <ReceiptLongOutlinedIcon />
        </IconWrapper>

        <Title>Boleto gerado</Title>
        <Description>
          Copie a linha digitável abaixo ou visualize o boleto para pagar no
          seu banco. A compensação pode levar até 3 dias úteis.
        </Description>

        {line && <LineField>{line}</LineField>}

        <CopyButton onClick={handleCopyLine} disabled={!canCopy}>
          {copied ? 'Copiado!' : 'Copiar linha digitável'}
        </CopyButton>

        {dueAtLabel && <DeadlineNotice>Vencimento: {dueAtLabel}</DeadlineNotice>}

        <ButtonsRow>
          <CloseButton type="button" onClick={onClose}>
            Fechar
          </CloseButton>
          <ViewBoletoButton
            type="button"
            onClick={handleOpenBoleto}
            disabled={!canOpenBoleto}
          >
            Visualizar boleto
          </ViewBoletoButton>
        </ButtonsRow>
      </ModalDialog>
    </ModalOverlay>
  );
};

export default ModalPaymentLinkBoleto;
